<div class="terms-section">
  <div class="d-flex justify-content-between align-items-center">
    <h4 class="main-title d-flex align-items-center">{{'agendaCase.Recommendation' | translate}}</h4>
  </div>
    <!-- <div class="modal-header without-top-style">
        {{'agendaCase.Recommendation' | translate}}
    </div> -->
    <ng-container *ngIf="votingListData && votingListData.pageData.length; else dataEmpty">
      <mat-tab-group class="tabs-treatments mt-4" [selectedIndex]="0"
      [ngClass]="{'hide-tabs-header': votingListData.pageData.length === 1}">
          <mat-tab [label]="('agendaCase.Recommendation' | translate) + ' ' + (i+1)" *ngFor="let voting of votingListData.pageData; index as i">
              <div class="row">
                  <div class="col-6">
                      <div class="terms-section-body">
                          <div class="card">
                              <div class="card-body">
                                  <ul>
                                      <li *ngFor="let recommend of voting.recommendationHistory">
                                          {{recommend.recommendation}}
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-6 meeting-details">
                      <div class="voting">
                          <div class="questionVotingSection">
                              <div class="voting-tabs">
                                  <div class="primary-tabs">
                                      <div class="tabs-nav">
                                          <label *ngFor='let tab of tabs' (click)='currentTabVal = tab.value'
                                              [class.active]='currentTabVal == tab.value'>{{tab.label}}</label>
                                      </div>
                                  </div>

                                  <div class="tabs-container tabs-section">

                                      <div class="attendees-answers" *ngIf="currentTabVal == 0">
                                        <div class="message-comments-container" *ngIf="voting.attendeeVotingAnswers.length">
                                          <div class="comments-list">
                                            <div class="comment-panel" *ngFor="let vote of voting.attendeeVotingAnswers; index as i;">
                                              <div class="reply-header d-sm-flex justify-content-between align-items-center">
                                                <div class="name-with-image small mb-3 mb-sm-0">
                                                  <div class="image-circle" [title]="vote.creator.creatorName">
                                                    <img *ngIf="vote.creator.creatorProfilePicture" [src]="vote.creator.creatorProfilePicture"
                                                      (error)="vote.creator.creatorProfilePicture = ''" />
                                                    <span *ngIf="!vote.creator.creatorProfilePicture">{{ vote.creator.creatorName | shortName }}</span>
                                                  </div>
                                                  <div class="name">
                                                    <h5>{{vote.creator.creatorName}}</h5>
                                                  </div>
                                                  <div class="delegated-user" *ngIf="vote.delegator && vote.delegator.creatorId">
                                                    <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                                                    <div class="image-circle" [title]="vote.delegator.creatorName">
                                                      <img *ngIf="vote.delegator.creatorProfilePicture" [src]="vote.delegator.creatorProfilePicture"
                                                        (error)="vote.delegator.creatorProfilePicture = ''" />
                                                      <span *ngIf="!vote.delegator.creatorProfilePicture">{{ vote.delegator.creatorName | shortName
                                                        }}</span>
                                                    </div>
                                                    <div class="creatorName">
                                                      ({{vote.delegator.creatorName}})
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="text-lg-right">
                                                  <p class="time-from"> {{ vote.answerDate | timeAgo }}</p>
                                                </div>
                                              </div>
                                              <div class="reply-content" [ngClass]="{'has-delegator': vote.delegator && vote.delegator.creatorId}">
                                                <div class="reply-body pt-1">
                                                  <div class="badge"
                                                    [ngClass]="{
                                                      'badge-success': vote.lookup == 'Approved',
                                                      'badge-danger': vote.lookup == 'Declined',
                                                      'badge-secondary': vote.lookup == 'Abstain'
                                                    }"
                                                    >{{vote.answer}}</div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="no-document pt-0" *ngIf="!voting.attendeeVotingAnswers.length">
                                          <img src="./assets/images/icons/no-comments.svg" alt="">
                                          <p> {{ 'case.No one vote yet' | translate }}!</p>
                                        </div>
                                      </div>

                                      <div class="summary" *ngIf="currentTabVal == 1">
                                        <ng-container *ngIf='voting.votingSummaryList.length'>
                                          <ul class="summery-progress">
                                            <li *ngFor="let item of voting.votingSummaryList; let i=index">
                                              <div class="sum-info">
                                                <span>{{item.title}}</span>
                                                <div class="stat">
                                                  <span class="perc">{{item.percentage | number:'1.0-2'}}%</span>
                                                  <span>
                                                    (
                                                    {{item.votesNumber}} <span *ngIf="item.votesNumber != 1"> {{ 'meetings.votes' | translate }}</span>
                                                    <span *ngIf="item.votesNumber == 1">{{ 'meetings.avote' | translate }}</span>
                                                    )
                                                  </span>
                                                </div>
                                              </div>
                                              <mat-progress-bar mode="determinate" [value]="item.percentage"></mat-progress-bar>
                                            </li>
                                          </ul>
                                        </ng-container>

                                        <div class="no-document pt-0" *ngIf='!voting.votingSummaryList.length'>
                                          <img src="./assets/images/icons/no-comments.svg" alt="">
                                          <p> {{ 'meetings.Nosummaryyet' | translate }}!</p>
                                        </div>
                                      </div>

                                    </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </mat-tab>
      </mat-tab-group>
    </ng-container>
    <ng-template #dataEmpty>
      <div class="data-empty no-bg">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="110"
              height="99.999" viewBox="0 0 110 99.999">
              <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                      <stop offset="0" stop-color="#469595" />
                      <stop offset="1" stop-color="#0b7ebc" />
                  </linearGradient>
                  <linearGradient id="linear-gradient-2" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                      <stop offset="0" stop-color="#469595" />
                      <stop offset="1" stop-color="#14374D" />
                  </linearGradient>
              </defs>
              <g id="no-members-illustration" transform="translate(-823 -642)">
                  <path id="Path_2516" data-name="Path 2516"
                      d="M99.268,21.663c0,22.014,11.315,37.132,11.315,47.74s-6.051,32.886-54.471,32.886S.583,72.318.583,60.65c0-54.637,98.685-77.975,98.685-38.987Z"
                      transform="translate(822.417 639.71)" fill="#efefef" opacity="0.6" />
                  <g id="Group_764" data-name="Group 764" transform="translate(839.484 647.141)">
                      <path id="Path_2517" data-name="Path 2517" d="M0,0H6.365V3.183H0Z"
                          transform="translate(12.941 4.508) rotate(-45)" fill="#9fbfcf" />
                      <path id="Path_2518" data-name="Path 2518" d="M0,0H6.365V3.183H0Z"
                          transform="translate(0 17.443) rotate(-45)" fill="#9fbfcf" />
                      <path id="Path_2519" data-name="Path 2519" d="M0,0H3.183V6.365H0Z"
                          transform="translate(0.562 2.25) rotate(-45)" fill="#9fbfcf" />
                  </g>
                  <path id="shadow"
                      d="M37.154,11.75H29A7.247,7.247,0,0,0,21.75,19v4.531H29.9V19A7.247,7.247,0,0,1,37.154,11.75Z"
                      transform="translate(870.018 657.366)" fill="#d5dbe1" />
                  <path id="Union_1" data-name="Union 1"
                      d="M-431.043,7160.122v-3.544a5.338,5.338,0,0,0-5.347-5.315h-10.7a5.338,5.338,0,0,0-5.347,5.315v3.544a1.778,1.778,0,0,1-1.783,1.771,1.777,1.777,0,0,1-1.783-1.771v-3.544a8.9,8.9,0,0,1,8.913-8.859h10.7a8.9,8.9,0,0,1,8.911,8.859v3.544a1.776,1.776,0,0,1-1.781,1.771A1.777,1.777,0,0,1-431.043,7160.122Zm-17.827-23.035a7.116,7.116,0,0,1,7.13-7.087,7.116,7.116,0,0,1,7.13,7.087,7.117,7.117,0,0,1-7.13,7.089A7.117,7.117,0,0,1-448.87,7137.087Zm3.566,0a3.557,3.557,0,0,0,3.564,3.544,3.559,3.559,0,0,0,3.566-3.544,3.558,3.558,0,0,0-3.566-3.543A3.557,3.557,0,0,0-445.3,7137.087Z"
                      transform="translate(1346.478 -6480.998)" fill="url(#linear-gradient)" />
                  <path id="shadow-2" data-name="shadow"
                      d="M14.909,36.413A22.658,22.658,0,0,1,33.492,14.134a22.656,22.656,0,1,0-4.079,44.941,22.879,22.879,0,0,0,4.079-.384A22.658,22.658,0,0,1,14.909,36.413Z"
                      transform="translate(831.25 662.25)" fill="#d5dbe1" />
                  <path id="Union_2" data-name="Union 2"
                      d="M-398.49,7189.673l-16.121-16.021a24.937,24.937,0,0,1-16.432,6.152A24.911,24.911,0,0,1-456,7155a24.911,24.911,0,0,1,24.958-24.8,24.911,24.911,0,0,1,24.956,24.8,24.615,24.615,0,0,1-6.017,16.137l16.135,16.032a1.768,1.768,0,0,1,0,2.506,1.781,1.781,0,0,1-1.26.518A1.792,1.792,0,0,1-398.49,7189.673ZM-452.435,7155a21.349,21.349,0,0,0,21.392,21.263A21.348,21.348,0,0,0-409.652,7155a21.347,21.347,0,0,0-21.391-21.26A21.348,21.348,0,0,0-452.435,7155Zm32.088,12.211v-3.544a5.338,5.338,0,0,0-5.349-5.314h-10.7a5.338,5.338,0,0,0-5.349,5.314v3.544a1.777,1.777,0,0,1-1.781,1.772,1.777,1.777,0,0,1-1.783-1.772v-3.544a8.9,8.9,0,0,1,8.912-8.858h10.7a8.9,8.9,0,0,1,8.912,8.858v3.544a1.777,1.777,0,0,1-1.781,1.772A1.777,1.777,0,0,1-420.348,7167.209Zm-17.827-23.033a7.116,7.116,0,0,1,7.131-7.088,7.115,7.115,0,0,1,7.13,7.088,7.115,7.115,0,0,1-7.13,7.086A7.115,7.115,0,0,1-438.174,7144.176Zm3.566,0a3.557,3.557,0,0,0,3.566,3.542,3.556,3.556,0,0,0,3.564-3.542,3.557,3.557,0,0,0-3.564-3.544A3.557,3.557,0,0,0-434.609,7144.176Z"
                      transform="translate(1293 -6456.192)" fill="url(#linear-gradient-2)" />
              </g>
          </svg>
          <p>{{ 'general.NoFound' | translate }}</p>
      </div>
  </ng-template>
</div>

